
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/phongvu/desktop/products/[sku]",
      function () {
        return require("private-next-pages/phongvu/desktop/products/[sku].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/phongvu/desktop/products/[sku]"])
      });
    }
  